import {type RouteObject} from 'react-router-dom';
import {URLPathname} from 'interfaces';
import TermsOfServiceView from 'containers/views/globalViews/TermsOfServiceView';
import PrivacyPolicyView from 'containers/views/globalViews/PrivacyPolicyView';

export const notAuthenticatedRoutes: RouteObject[] = [
  {
    path: URLPathname.privacyPolicy,
    element: <PrivacyPolicyView />,
  },
  {
    path: URLPathname.termsofService,
    element: <TermsOfServiceView />,
  },
];
